// material-ui
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";

// assets

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

export default function Search() {
  return (
    <Box sx={{ width: "100%", ml: { xs: 0, md: 1 } }}>
      <FormControl sx={{ width: { xs: "100%", md: 224 } }}></FormControl>
    </Box>
  );
}
